import React from 'react';

import cl from 'classnames';
import s from './FlatButton.css';

const FlatButton = React.forwardRef(({children, className, style, ...props}, ref) => (
  <button ref={ref} className={cl(s.Button, className)} style={style} {...props}>
    {children}
  </button>
));

export default FlatButton;
